import { getFieldLabel } from 'util/fields-labels/util-fieldsLabels'
import { MetaPath } from 'util/metaPath'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'

import { soapFormLabels } from './soapFormLabels'

export const getSoapFieldLabel = <FieldModel>(fieldName: MetaPath<FieldModel>): string => {
  return getFieldLabel<FieldModel, SoapState>(fieldName, soapFormLabels)
}
